import { render, staticRenderFns } from "./floatBtn.vue?vue&type=template&id=298f401b&scoped=true&"
import script from "./floatBtn.vue?vue&type=script&lang=js&"
export * from "./floatBtn.vue?vue&type=script&lang=js&"
import style0 from "./floatBtn.vue?vue&type=style&index=0&id=298f401b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f401b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298f401b')) {
      api.createRecord('298f401b', component.options)
    } else {
      api.reload('298f401b', component.options)
    }
    module.hot.accept("./floatBtn.vue?vue&type=template&id=298f401b&scoped=true&", function () {
      api.rerender('298f401b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/floatBtn.vue"
export default component.exports